import React from 'react'
import { connect } from 'react-redux'
import {
	Stepper,
	Step,
	StepLabel,
	withStyles,
	StepButton,
	Tooltip,
} from '@material-ui/core'
import { bindActionCreators } from 'redux'
import { stepperGoTo } from 'actions/view'

const StepperComponent = ({
	activeStep,
	steps,
	classes,
	formID,
	stepperGoTo,
	formTypeSelected,
	internal_type,
}) => {
	return (
		<Stepper
			classes={{ root: classes.root }}
			activeStep={activeStep}
			alternativeLabel
			nonLinear
		>
			{steps.map((step, idx) => {
        const stepComponent = (
          <Step key={step.label}>
            <StepButton
              disabled={
                /* internal_type === 'ci1' ||
								formTypeSelected === 'customIntegration'
									? idx === 1
									:  */ formID === 'new' && ((!formTypeSelected && idx > 0) || idx > 1)
              }
              icon={step.Icon}
              onClick={() => stepperGoTo(idx, 'form')}
            >
              <StepLabel
                classes={{ alternativeLabel: classes.alternativeLabel }}
              >
                {step.label}
              </StepLabel>
            </StepButton>
          </Step>
        )

        if (formID === 'new' && !formTypeSelected && idx === 1) {
          return (
            <Tooltip
              key={`addOrEditFormPageStep${idx}`}
              title={'This step is disabled when form type is not selected.'}
            >
              {stepComponent}
            </Tooltip>
          )
        }

        if (formID === 'new' && idx > 1) {
          return (
            <Tooltip
              key={`addOrEditFormPageStep${idx}`}
              title={`This step is disabled until the ${
                formTypeSelected === 'customIntegration'
                  ? 'custom integration'
                  : 'form'
              } is saved.`}
            >
              {stepComponent}
            </Tooltip>
          )
        }

        // if (formTypeSelected === 'customIntegration' && idx === 1) {
        // 	return (
        // 		<Tooltip
        // 			key={`addOrEditFormPageStep${idx}`}
        // 			title="This step is not available for custom integrations."
        // 		>
        // 			{stepComponent}
        // 		</Tooltip>
        // 	)
        // }

        return stepComponent
      })}
		</Stepper>
	)
}
const styles = (theme) => ({
	root: {
		padding: 0,
		[theme.breakpoints.up('md')]: {
			width: 500,
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: 10,
		},
		// marginTop: '-9px',
	},
	alternativeLabel: {
		marginTop: '0px !important',
		whiteSpace: 'nowrap',
		[theme.breakpoints.down('sm')]: {
			fontSize: 10,
		},
	},
})

export default connect(
	(state) => ({
		activeStep: state.view.stepper.form,
		formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
		internal_type: state.customForm?.addOrEdit?.internal_type,
	}),
	(dispatch) => bindActionCreators({ stepperGoTo }, dispatch),
)(withStyles(styles)(StepperComponent))
